@if (productData) {
<section class="section-7 bg-gray-20 py-4">
    @let overviewKeys = { headingText:
    'PRODUCT-PAGE_GLOBAL_SPECIFICATIONS_HEADING_TEXT' | translate,
    descriptionText: 'PRODUCT-PAGE_GLOBAL_SPECIFICATIONS_DESCRIPTION_TEXT' |
    translate }; @if (overviewKeys.headingText || overviewKeys.descriptionText)
    {
    <div class="container text-center my-4">
        <div class="row justify-content-center">
            <div class="col-12 col-xl-10">
                @if (overviewKeys.headingText) {
                <h3 [innerHTML]="overviewKeys.headingText" class="mb-0"></h3>
                } @if (overviewKeys.descriptionText) {
                <div [innerHTML]="overviewKeys.descriptionText"></div>
                }
            </div>
        </div>
    </div>
    }

    <div class="container pb-4">
        <div class="row justify-content-center">
            <div class="d-none d-lg-block col-12 col-lg-10 col-xl-8">
                @if (groupedAttributes && ((groupedAttributes | keyvalue) ??
                []).length > 0) {
                <div>
                    @for (group of groupedAttributes | keyvalue: originalOrder;
                    track group; let first = $first; let last = $last;) {
                    <div
                        [ngClass]="[
                            first ? 'spec-group-border' : 'pt-4',
                            last ? '' : 'spec-group-border pb-4 '
                        ]"
                        class="spec-group"
                    >
                        <p [innerHtml]="group.key" class="lead mb-2"></p>

                        @for (attribute of group.value; track attribute; let
                        last = $last;) {
                        <div
                            [ngClass]="last ? '' : 'mb-2'"
                            class="product-spec"
                        >
                            <div class="row justify-content-center">
                                <div class="col-5">
                                    <p
                                        [innerHtml]="
                                            attribute.attributeMarketingName
                                        "
                                        class="mb-0"
                                    ></p>
                                </div>
                                <div class="col-7">
                                    <p
                                        [innerHtml]="
                                            attribute.attributeMarketingValue
                                        "
                                        class="mb-0"
                                    ></p>
                                </div>
                            </div>
                        </div>
                        }
                    </div>
                    }
                </div>
                }
            </div>

            <div class="d-block d-lg-none col-12">
                <div class="accordion" id="accordionPanelsStayOpenExample">
                    @if (groupedAttributes && ((groupedAttributes | keyvalue) ??
                    []).length > 0) { @for (group of groupedAttributes |
                    keyvalue : originalOrder; track group; let first = $first;
                    let i = $index;) {
                    <div class="accordion-item">
                        <p class="accordion-header lead">
                            <button
                                (click)="toggleAccordion(i)"
                                [innerHTML]="group.key"
                                [class.collapsed]="!isAccordionOpen(i)"
                                class="accordion-button"
                                type="button"
                                [attr.aria-expanded]="isAccordionOpen(i)"
                                [attr.aria-controls]="'accordion' + i"
                            ></button>
                        </p>

                        @if (isAccordionOpen(i)) {
                        <div [id]="'accordion' + i" class="accordion-collapse">
                            <div class="accordion-body">
                                <div class="row gy-3">
                                    @for (attribute of group.value; track
                                    attribute;) {
                                    <div class="col-12">
                                        <p
                                            [innerHtml]="
                                                attribute.attributeMarketingName
                                            "
                                            class="m-0"
                                        ></p>
                                        <p
                                            [innerHtml]="
                                                attribute.attributeMarketingValue
                                            "
                                            class="m-0"
                                        ></p>
                                    </div>
                                    }
                                </div>
                            </div>
                        </div>
                        }
                    </div>
                    } }
                </div>
            </div>
        </div>
    </div>
</section>
}
